import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SearchService } from '../../services/search.service';
import { MapService } from '../../services/map.service';
import { Observable, Subscriber, throwError } from 'rxjs';
import { FormControl } from '@angular/forms';
import { SingleSearchLocation } from 'src/app/_models/pcmws/singleSearch/singleSearchResponse';
import { catchError, map, switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-single-search',
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
  searchString = '';
  dataSource$: Observable<unknown>;
  isError = false;
  errorMessage = '';
  @Output() startSearch = new EventEmitter<any>();
  @ViewChild('search') search: ElementRef;
  constructor(
    private searchService: SearchService,
    private mapService: MapService
  ) {}
  ngOnInit(): void {
    setTimeout(() => this.search?.nativeElement?.focus());
  }
  onSearch(searchValue: string) {
    // Runs on every search
    this.dataSource$ = this.searchService
      .search(
        this.searchString,
        this.mapService.getRegion(),
        this.mapService.getMapCenter()
      )
      .pipe(
        map((result) => {
          this.isError = false;
          return result;
        }),
        catchError((error) => {
          this.isError = true;
          this.errorMessage = 'Server Error. Try again later.';
          return error;
        })
      );
  }
  onSelect(event): void {
    this.startSearch.emit(event.item);
    this.searchString = '';
    setTimeout(() => this.search?.nativeElement?.blur());
  }
}
